import { Button } from "@ui/shad"
import { Mail, RefreshCw, Settings } from "lucide-react"

export default function EmailBackground({ hideSearch }: { hideSearch?: boolean }) {
  const emailGroups = [
    {
      title: "Today",
      emails: [
        {
          subject: "Weekly Sales Report - Q4 Performance",
          sender: "Sarah Johnson",
          preview:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          time: "2:30 PM",
        },
        {
          subject: "Meeting Request: Product Roadmap Discussion",
          sender: "Michael Chen",
          preview:
            "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          time: "1:15 PM",
        },
        {
          subject: "Invoice #12345 - Payment Due",
          sender: "Accounting Team",
          preview:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
          time: "11:45 AM",
        },
      ],
    },
    {
      title: "Yesterday",
      emails: [
        {
          subject: "Project Update: Mobile App Development",
          sender: "Alex Thompson",
          preview:
            "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
          time: "4:20 PM",
        },
        {
          subject: "Welcome to our platform!",
          sender: "Support Team",
          preview: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
          time: "2:45 PM",
        },
      ],
    },
    {
      title: "This Week",
      emails: [
        {
          subject: "Newsletter: Industry Trends and Insights",
          sender: "Marketing Team",
          preview:
            "Totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt.",
          time: "Mon",
        },
        {
          subject: "Security Alert: Password Change Required",
          sender: "Security Team",
          preview:
            "Explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur.",
          time: "Sun",
        },
      ],
    },
    {
      title: "Earlier",
      emails: [
        {
          subject: "Customer Feedback Survey Results",
          sender: "Analytics Team",
          preview:
            "Magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum.",
          time: "Dec 15",
        },
        {
          subject: "Holiday Schedule Announcement",
          sender: "HR Department",
          preview: "Quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
          time: "Dec 12",
        },
      ],
    },
  ]

  return (
    <>
      {!hideSearch && (
        <div className="bg-background flex items-center justify-between gap-4 border-b p-4">
          <div className="relative w-[300px]">
            <div className="text-muted-foreground flex h-10 items-center rounded-md border px-3 text-sm">
              Search emails...
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" className="text-icon">
              <RefreshCw />
            </Button>
            <Button variant="outline" size="icon" className="text-icon">
              <Settings />
            </Button>

            <Button>
              <Mail className="text-icon-secondary" />
              Send email
            </Button>
          </div>
        </div>
      )}
      <div className="space-y-8 p-4">
        {emailGroups.map((group, groupIndex) => (
          <div key={groupIndex} className="space-y-4">
            <h3 className="text-muted-foreground text-sm font-medium">{group.title}</h3>
            {group.emails.map((email, emailIndex) => (
              <div key={emailIndex} className="border-border flex items-start gap-4 border-b pb-4">
                <div className="flex-1 space-y-2">
                  <div className="text-sm font-medium">{email.subject}</div>
                  <div className="text-muted-foreground text-xs">{email.sender}</div>
                  <div className="text-muted-foreground line-clamp-2 text-xs">{email.preview}</div>
                </div>
                <div className="text-muted-foreground text-xs">{email.time}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  )
}
